@import (reference) '../../../../../../constants/spacing.module.less';

.max-ship-days {
  align-items: center;
  display: flex;
  margin-bottom: @space-24;
  gap: @space-4;
}

.max-ship-days-wrapper {
  display: inline-block;
  margin: 0 5px;

  input {
    width: 65px;
    font-size: 12px;
  }
}

.return-service-and-package {
  margin-bottom: @space-8;
}

.pref-input-wrapper {
  margin-bottom: @space-24;
}

.add-funds-button {
  font-size: 12px;
}

.package-dropdown {
  width: 100%;
}

.standardReturnsSectionContent {
  padding: @space-16;
  display: grid;
  grid-template-columns: 1fr 1fr;
}

h3.title {
  margin: 0;
}
